import ReactECharts from 'echarts-for-react';
import { METRIC_DEFINITIONS } from '../constants/metrics';
import { createRadarChartOptions } from '../charts/metricChartOptions';

const buildCategoryPieData = (steps) => {
  if (!steps?.length) {
    return [{ name: 'Нет данных', value: 1 }];
  }

  const categoryCount = {};
  steps.forEach((step) => {
    categoryCount[step.category] = (categoryCount[step.category] || 0) + 1;
  });

  return Object.entries(categoryCount).map(([category, count]) => ({
    name: category,
    value: count,
  }));
};

const TeamDetailView = ({
  team,
  theme,
  detailViewType,
  onDetailViewTypeChange,
  onClose,
  getTeamMetrics,
}) => {
  const metrics = getTeamMetrics(team);
  const isDark = theme === 'dark';

  return (
    <div className="detail-view-modal">
      <div className="detail-view-content">
        <div className="detail-view-header">
          <h3>Детальный просмотр: {team.name}</h3>
          <button onClick={onClose} className="close-btn" type="button">
            ✕
          </button>
        </div>

        <div className="detail-view-navigation">
          <button
            type="button"
            className={`detail-nav-btn ${detailViewType === 'metrics' ? 'active' : ''}`}
            onClick={() => onDetailViewTypeChange('metrics')}
          >
            📊 Метрики
          </button>
          <button
            type="button"
            className={`detail-nav-btn ${detailViewType === 'steps' ? 'active' : ''}`}
            onClick={() => onDetailViewTypeChange('steps')}
          >
            📝 Шаги процесса
          </button>
          <button
            type="button"
            className={`detail-nav-btn ${detailViewType === 'charts' ? 'active' : ''}`}
            onClick={() => onDetailViewTypeChange('charts')}
          >
            📈 Графики
          </button>
        </div>

        <div className="detail-view-body">
          {detailViewType === 'metrics' && (
            <div className="metrics-detail-view">
              <div className="team-detail-info">
                <h4>Информация о команде</h4>
                <div className="info-grid">
                  <div className="info-item">
                    <strong>Название:</strong> {team.name}
                  </div>
                  <div className="info-item">
                    <strong>Описание:</strong> {team.description || 'Не указано'}
                  </div>
                  <div className="info-item">
                    <strong>Статус:</strong>{' '}
                    {team.status === 'active'
                      ? '🟢 Активная'
                      : team.status === 'inactive'
                        ? '🟡 Неактивная'
                        : '🔴 Архивная'}
                  </div>
                  <div className="info-item">
                    <strong>Количество шагов:</strong> {team.stepsCount ?? team.steps?.length ?? 0}
                  </div>
                  <div className="info-item">
                    <strong>Создана:</strong>{' '}
                    {team.createdAt ? new Date(team.createdAt).toLocaleString() : 'Не указана'}
                  </div>
                  <div className="info-item">
                    <strong>Обновлена:</strong>{' '}
                    {new Date(team.lastModified || team.updatedAt).toLocaleString()}
                  </div>
                </div>
              </div>

              <div className="metrics-detail-charts">
                <h4>Детальные метрики</h4>
                <div className="metrics-grid">
                  {METRIC_DEFINITIONS.map(({ key, title, detailColor }) => (
                    <div key={key} className="metric-detail-card">
                      <h5>{title}</h5>
                      <div className="metric-progress">
                        <div
                          className="metric-progress-bar"
                          style={{
                            width: `${metrics[key]}%`,
                            backgroundColor: detailColor,
                          }}
                        />
                      </div>
                      <div className="metric-value">{metrics[key].toFixed(1)}%</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {detailViewType === 'steps' && (
            <div className="steps-detail-view">
              <h4>Шаги процесса команды &quot;{team.name}&quot;</h4>
              {team.steps?.length ? (
                <div className="steps-list">
                  {team.steps.map((step, index) => (
                    <div key={`${step.code}-${index}`} className="step-item">
                      <div className="step-number">{index + 1}</div>
                      <div className="step-content">
                        <div className="step-category">{step.category}</div>
                        <div className="step-product">{step.product}</div>
                        <div className="step-action">{step.action}</div>
                        {step.code && <div className="step-code">Код: {step.code}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-steps">
                  <p>У команды пока нет сохраненных шагов процесса</p>
                </div>
              )}
            </div>
          )}

          {detailViewType === 'charts' && (
            <div className="charts-detail-view">
              <h4>Графики команды &quot;{team.name}&quot;</h4>
              <div className="detail-charts-grid">
                <div className="detail-chart-container">
                  <h5>Радарная диаграмма метрик</h5>
                  <ReactECharts
                    option={createRadarChartOptions(team, metrics, isDark)}
                    style={{ height: '400px' }}
                  />
                </div>
                <div className="detail-chart-container">
                  <h5>Круговая диаграмма шагов по категориям</h5>
                  <ReactECharts
                    option={{
                      title: {
                        text: 'Распределение шагов по категориям',
                        left: 'center',
                        textStyle: { color: isDark ? '#e2e8f0' : '#333333' },
                      },
                      series: [
                        {
                          type: 'pie',
                          radius: '50%',
                          data: buildCategoryPieData(team.steps),
                          label: {
                            color: isDark ? '#cbd5e0' : '#333333',
                            fontSize: 12,
                          },
                          labelLine: {
                            lineStyle: { color: isDark ? '#4a5568' : '#ddd' },
                          },
                        },
                      ],
                    }}
                    style={{ height: '400px' }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamDetailView;
